import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
export function ProofSection() {
  const proofs = ['+8 años de experiencia en administración de empresas en Estados Unidos', 'Notaria certificada en Florida — con autoridad para validar documentos oficiales', 'Formación especializada en Comunicación, RRPP, Publicidad y Diseño', 'Proceso claro y acompañado — no te dejamos solo después del registro', 'Atención personalizada — cada emprendedor tiene una situación distinta y la tratamos como tal', 'Experiencia con emprendedores latinos dentro y fuera de Estados Unidos'];
  return <section className="py-24 bg-inkova-primary text-white" data-id="element-388">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-389">
        <div className="text-center mb-16" data-id="element-390">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-serif text-inkova-accent mb-6" data-id="element-391">
            ¿Por qué confiar en&nbsp;Inkova?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-300 font-light max-w-3xl mx-auto" data-id="element-392">
            No somos una plataforma automática. No somos un formulario en línea.
            No somos una respuesta genérica&nbsp;de&nbsp;Google.
            <br data-id="element-393" />
            <br data-id="element-394" />
            <span className="font-medium text-white" data-id="element-395">
              Somos personas reales acompañando a personas&nbsp;reales.
            </span>
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-inkova-accent/10 p-8 md:p-10 rounded-2xl border border-inkova-accent/30 text-center max-w-4xl mx-auto" data-id="element-396">
          <p className="text-xl md:text-2xl font-serif italic text-inkova-accent" data-id="element-397">
            "Entendemos lo que significa empezar desde cero en un país nuevo.
            Entendemos el idioma, la cultura y el miedo. Y entendemos
            exactamente qué necesitas&nbsp;para&nbsp;avanzar."
          </p>
        </motion.div>
      </div>
    </section>;
}